var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCbeth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.6 128C249.6 60.842 195.158 6.4 128 6.4 60.842 6.4 6.4 60.842 6.4 128c0 67.158 54.442 121.6 121.6 121.6 67.158 0 121.6-54.442 121.6-121.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 38.4-54.097 91.376L128 104.653V38.4Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 162.061-54.097-32.4L128 104.653v57.408Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.995 172.663-54.092-32.41 54.092 77.347v-44.937Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 38.4 54.095 91.376L128 104.653V38.4Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 162.061 54.095-32.285L128 104.653v57.408Z",
    fill: "#CCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128 172.663 54.095-31.824L128 217.6v-44.937Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 12.8C64.377 12.8 12.8 64.377 12.8 128c0 63.623 51.577 115.2 115.2 115.2 63.623 0 115.2-51.577 115.2-115.2 0-63.623-51.577-115.2-115.2-115.2ZM0 128C0 57.308 57.308 0 128 0c70.692 0 128 57.308 128 128 0 70.692-57.308 128-128 128C57.308 256 0 198.692 0 128Z",
    fill: "#0052FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v256H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbeth);
export default __webpack_public_path__ + "static/media/cbeth.ac1390c3b88aaa2d1045956055a90019.svg";
export { ForwardRef as ReactComponent };